/**
 * Bloc « Mes évals » du tableau de bord élève (migration 0321) : la prochaine
 * éval avec son compte à rebours et les SKILLCARDS à réviser, les évals à
 * noter, ou une invitation à programmer la première.
 */

import { Link } from '@tanstack/react-router';
import { ChevronRight, ClipboardList } from 'lucide-react';
import { bucketEvaluations, type StudentEvaluation } from '@/lib/evaluations/grades';
import { UpcomingEvaluation } from './evaluations-page';

export function EvaluationsDashboardCard({
  evaluations,
  masteryById,
}: {
  evaluations: readonly StudentEvaluation[] | undefined;
  masteryById: ReadonlyMap<string, number>;
}) {
  if (!evaluations) return null;
  const { upcoming, toGrade } = bucketEvaluations(evaluations);
  const next = upcoming[0];

  return (
    <section aria-labelledby="evals-title" className="space-y-2">
      <div className="flex items-center justify-between gap-3">
        <h2 id="evals-title" className="font-display text-ink-900 text-lg font-bold">
          Mes évals
        </h2>
        <Link
          to="/student/evaluations"
          className="text-primary-600 inline-flex min-h-[2.75rem] items-center gap-1 text-sm font-semibold"
        >
          Mes notes <ChevronRight className="h-4 w-4" aria-hidden />
        </Link>
      </div>

      {next ? (
        <UpcomingEvaluation evaluation={next} masteryById={masteryById} maxCards={3} />
      ) : evaluations.length === 0 ? (
        <Link
          to="/student/evaluations"
          className="border-primary-200 bg-primary-50/60 ocean:bg-white/5 flex items-center gap-3 rounded-2xl border p-4 active:scale-[0.98]"
        >
          <span className="bg-primary-600 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-white">
            <ClipboardList className="h-5 w-5" aria-hidden />
          </span>
          <span className="min-w-0">
            <span className="text-ink-900 block font-semibold">
              Programme ton prochain contrôle
            </span>
            <span className="text-ink-600 block text-sm">
              On te dira quelles SKILLCARDS réviser, et ta moyenne se calcule toute seule.
            </span>
          </span>
        </Link>
      ) : (
        <p className="text-ink-500 text-sm">Aucune éval à venir.</p>
      )}

      {toGrade.length > 0 && (
        <Link
          to="/student/evaluations"
          className="border-accent-300 bg-accent-50 ocean:bg-accent-500/10 text-ink-900 flex min-h-[2.75rem] items-center justify-between gap-3 rounded-2xl border px-4 py-2 text-sm font-semibold active:scale-[0.98]"
        >
          <span>
            {toGrade.length === 1
              ? '1 éval à noter : as-tu reçu ta note ?'
              : `${toGrade.length} évals à noter`}
          </span>
          <ChevronRight className="h-4 w-4 shrink-0" aria-hidden />
        </Link>
      )}
    </section>
  );
}
